module.exports = __webpack_public_path__ + "img/IMG_8959.69208943.jpg";